import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../constants'

const Down = styled.div`
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid;
    display: inline-block;
    height: 0;
    vertical-align: super;
    width: 0;

    ${({ colored }) => (colored ? `border-top: 10px solid ${colors.red};` : `border-top: 10px solid ${colors.white};`)}
`

const Up = styled.div`
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    display: inline-block;
    height: 0;
    vertical-align: super;
    width: 0;

    ${({ colored }) => (colored ? `border-bottom: 10px solid ${colors.green};` : `border-bottom: 10px solid ${colors.white};`)}
`

const Left = styled.div`
    border-bottom: 10px solid transparent;
    border-top: 10px solid transparent;
    display: inline-block;
    height: 0;
    vertical-align: super;
    width: 0;

    ${({ colored }) => (colored ? `border-right: 10px solid ${colors.blue};` : `border-right: 10px solid ${colors.white};`)}
`

const Right = styled.div`
    border-bottom: 10px solid transparent;
    border-top: 10px solid transparent;
    display: inline-block;
    height: 0;
    vertical-align: super;
    width: 0;

    ${({ colored }) => (colored ? `border-left: 10px solid ${colors.blue};` : `border-left: 10px solid ${colors.white};`)}
`

const Stay = styled.div`
    display: inline-block;
    height: 0;
    vertical-align: super;
    width: 20px;

    ${({ colored }) => (colored ? `border-bottom: 4px solid ${colors.greylight};` : `border-bottom: 4px solid ${colors.white};`)}
`

class Arrow extends PureComponent {
    static propTypes = {
        direction: PropTypes.oneOf(['up', 'down', 'left', 'right', 'stay']),
        colored: PropTypes.bool,
    }

    static defaultProps = {
        direction: 'stay',
        colored: false,
    }

    render() {
        const { colored, direction } = this.props

        switch (direction) {
            case 'down':
                return <Down colored={colored} />
            case 'up':
                return <Up colored={colored} />
            case 'left':
                return <Left colored={colored} />
            case 'right':
                return <Right colored={colored} />
            case 'stay':
            default:
                return <Stay colored={colored} />
        }
    }
}

export default Arrow
